import { Box, Button, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import CommentEditor from '../editor/CommentEditor';
import { CANtrackComment } from '../../types/comment';
import { AddIcon, RemoveIcon } from 'components/icons';
import useCommentEditor from '../../hooks/useCommentEditor';

const CommentManager: React.FC<{
	setComments: React.Dispatch<React.SetStateAction<CANtrackComment[]>>;
	commentToCopy?: CANtrackComment;
	resetCommentToCopy: () => void;
	userId?: string; // used to create comments for a different user than the logged in user - used in timesheets
	contactId?: string; // used to create comments for a different user than the logged in user - used in timesheets
	searchQuery?: string;
	onSearchChange?: (query: string) => void;
}> = (props) => {
	const [open, setOpen] = React.useState(false);
	const {
		errors,
		formState,
		handleChange,
		handleSaveComment,
		handleResetComment,
	} = useCommentEditor(
		props.setComments,
		props.commentToCopy,
		props.userId,
		props.contactId,
	);

	useEffect(() => {
		if (props.commentToCopy) {
			setOpen(true);
		}
	}, [props.commentToCopy]);

	useEffect(() => {
		if (!open) {
			// reset states when closing the editor
			resetStates();
		}
	}, [open]);

	const resetStates = () => {
		handleResetComment();
		props.resetCommentToCopy();
	};

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					justifyContent: 'space-between',
					gap: 1,
				}}
			>
				<Button
					variant="contained"
					onClick={() => setOpen(!open)}
					startIcon={open ? <RemoveIcon /> : <AddIcon />}
					size="small"
					sx={{ alignSelf: { xs: 'stretch', sm: 'center' }, height: 40 }}
				>
					New Comment
				</Button>
				<TextField
				label="Search"
				sx={{ width: { xs: '100%', sm: 300 } }}
				size="small"
				value={props.searchQuery ?? ''}
				onChange={(e) => props.onSearchChange?.(e.target.value)}
			/>
			</Box>
			{open && (
				<CommentEditor
					errors={errors}
					formState={formState}
					handleChange={handleChange}
					handleSave={handleSaveComment}
					handleReset={resetStates}
					handleDelete={() => {}} // can't delete a new comment
				/>
			)}
		</>
	);
};

export default CommentManager;
